import { MediaType } from "./types";
import { stripTags } from "@kaltura/mediaspace-shared-utils";

export const areMediaArraysEqual = (arr1: MediaType[], arr2: MediaType[]): boolean => {
    if (arr1.length !== arr2.length) {
        return false;
    }

    // Compare each media item by ID and position (order)
    return arr1.every((item, index) => {
        return item.entry.id === arr2[index].entry.id;
    });
};

export const normalizeText = (text: string) => stripTags(text).replace(/\s+/g, " ").trim();
